import { UseFormReturn } from 'react-hook-form'

import { Button } from '@tribeplatform/react-ui-kit/Button'

import { T } from '../../i18n/index.js'

import { PollFormValues } from './types.js'

interface PollSubmitProps {
  form: UseFormReturn<PollFormValues>
  onCancel: () => void
  isLoading?: boolean
  mode: 'create' | 'edit'
}

export function PollFormSubmit({
  form,
  onCancel,
  isLoading,
  mode,
}: PollSubmitProps) {
  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="tertiaryNeutral"
        size="lg"
        type="button"
        onClick={onCancel}
        disabled={isLoading}
      >
        <T id="Generics.Cancel" defaultMessage="Cancel" />
      </Button>
      <Button
        variant="primary"
        size="lg"
        type="submit"
        disabled={isLoading || !form.formState.isValid}
        loading={isLoading}
      >
        {mode === 'create' ? (
          <T id="Generics.CreatePoll" defaultMessage="Create poll" />
        ) : (
          <T id="Generics.UpdatePoll" defaultMessage="Update poll" />
        )}
      </Button>
    </div>
  )
}
